import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static classes = ['closed']
  static targets = ['modal']

  connect() {
    this.boundHandleBackdropPointer = this.#handleBackdropPointer.bind(this)
    this.modalTarget.addEventListener(
      'pointerdown',
      this.boundHandleBackdropPointer
    )
  }

  disconnect() {
    this.modalTarget.removeEventListener(
      'pointerdown',
      this.boundHandleBackdropPointer
    )
  }

  close() {
    this.modalTarget.close()
  }

  open() {
    // we add the class here so it doesn't animate on page load
    this.modalTarget.classList.add(this.closedClass)
    this.modalTarget.showModal()
  }

  // fix for closing via tap on mobile since click behaves weirdly with modal
  // backdrops on iOS
  #handleBackdropPointer(event) {
    if (event.target === this.modalTarget) this.close()
  }
}
